// i18n keys of the multi-tenant work package "popups" (owner 2026-10-03: every outbound email opens an
// editor first) — en / zh / th. ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  pop_from: 'From',
  pop_to: 'To',
  pop_cc: 'Cc',
  pop_subject: 'Subject',
  pop_body: 'Body',
  pop_send: 'Send',
  pop_sending: 'Sending…',
  pop_loading: 'Preparing the email…',
  pop_need_to: 'Enter at least one valid recipient.',
  pop_need_subject: 'Enter a subject.',
  pop_tr_title: 'Re-send the corrected custody notice',
  pop_tr_correction: 'Goes out as a correction, replying on the thread of the notice of {{at}}.',
  pop_tr_reply: 'Goes out as a reply on the thread of the earlier notice.',
  pop_jc_email: 'The email — check it, edit it, then send',
  pop_jc_draft_error: 'The email could not be prepared: {{msg}}',
  pop_jc_docs_below: 'The paragraph in the documents box is added under this body when the documents go with it.',
  pop_dd_email: 'The email — check it and edit it before sending',
  pop_dd_link_hint: '{{ph}} is replaced by the new client link when you press Send. Sending ends the previous client link.',
  pop_dd_edited: 'You have edited the email, so changes to the boxes above no longer update it.',
  pop_dd_rebuild: 'Rebuild the email from the boxes above',
  pop_need_body: 'The email body is empty.',
  pop_too_large: 'This email is over the 50 MB limit for one send (pasted images count towards it). Nothing was sent — make it smaller, e.g. remove large pasted images, and send again.',
  pop_jc_changed: 'The job changed — reload the email',
  pop_jc_changed_hint: 'Its status, finish date or recipients changed after this email was prepared, so it cannot be sent as shown. Reload the email to see it for the job as it stands now — anything you edited here is replaced.',
  pop_jc_reload: 'Reload the email',
  pop_jc_reloaded: 'The job changed, so the email below was reloaded for the job as it stands now. Check it before sending.',
  pop_jc_no_draft: 'The email has not been prepared.',
  pop_jc_wait_draft: 'Confirm & Send stays off until the email loads — Re-check / Edit and Revert still work.',
  pop_jc_retry: 'Try again',
};

export const zh: Record<string, string> = {
  pop_from: '发件人',
  pop_to: '收件人',
  pop_cc: '抄送',
  pop_subject: '主题',
  pop_body: '正文',
  pop_send: '发送',
  pop_sending: '发送中…',
  pop_loading: '正在准备邮件…',
  pop_need_to: '请至少填写一个有效的收件人。',
  pop_need_subject: '请填写主题。',
  pop_tr_title: '重发更正后的保管通知',
  pop_tr_correction: '作为更正发出,回复在 {{at}} 那封通知的邮件线程里。',
  pop_tr_reply: '作为回复发出,接在之前那封通知的邮件线程里。',
  pop_jc_email: '邮件内容 —— 检查、修改后再发送',
  pop_jc_draft_error: '无法生成邮件:{{msg}}',
  pop_jc_docs_below: '随附文件时,文件框里的那段文字会接在这段正文下面。',
  pop_dd_email: '邮件内容 —— 发送前检查并可修改',
  pop_dd_link_hint: '按下发送时,{{ph}} 会被替换成新的客户链接;发送后旧的客户链接即失效。',
  pop_dd_edited: '你已修改过邮件,上面几栏的改动不会再自动更新邮件。',
  pop_dd_rebuild: '按上面几栏重新生成邮件',
  pop_need_body: '邮件正文是空的。',
  pop_too_large: '这封邮件超过单次发送 50 MB 的上限(粘贴的图片也计入)。没有发出 —— 请缩小后再发,例如删掉粘贴进去的大图。',
  pop_jc_changed: '这个 Job 已有改动 —— 请重新载入邮件',
  pop_jc_changed_hint: '这封邮件准备好之后,Job 的状态、完成日期或收件人有了变化,所以不能按现在显示的内容发送。重新载入后会按 Job 当前的情况生成邮件 —— 你在这里改过的内容会被替换。',
  pop_jc_reload: '重新载入邮件',
  pop_jc_reloaded: '这个 Job 有改动,下面的邮件已按 Job 当前的情况重新载入。发送前请再检查一遍。',
  pop_jc_no_draft: '邮件还没有生成。',
  pop_jc_wait_draft: '邮件载入之前「确认并发送」不可用 ——「再次检查 / 编辑」和「还原」照常可用。',
  pop_jc_retry: '重试',
};

export const th: Record<string, string> = {
  pop_from: 'จาก',
  pop_to: 'ถึง',
  pop_cc: 'สำเนา',
  pop_subject: 'หัวเรื่อง',
  pop_body: 'เนื้อหา',
  pop_send: 'ส่ง',
  pop_sending: 'กำลังส่ง…',
  pop_loading: 'กำลังเตรียมอีเมล…',
  pop_need_to: 'กรุณาระบุผู้รับที่ถูกต้องอย่างน้อยหนึ่งราย',
  pop_need_subject: 'กรุณาระบุหัวเรื่อง',
  pop_tr_title: 'ส่งใบแจ้งการรับ/คืนเอกสารฉบับแก้ไขอีกครั้ง',
  pop_tr_correction: 'ส่งเป็นฉบับแก้ไข โดยตอบกลับในเธรดของใบแจ้งวันที่ {{at}}',
  pop_tr_reply: 'ส่งเป็นการตอบกลับในเธรดของใบแจ้งฉบับก่อน',
  pop_jc_email: 'อีเมล — ตรวจสอบ แก้ไข แล้วจึงส่ง',
  pop_jc_draft_error: 'ไม่สามารถเตรียมอีเมลได้: {{msg}}',
  pop_jc_docs_below: 'เมื่อแนบเอกสารไปด้วย ข้อความในช่องเอกสารจะต่อท้ายเนื้อหานี้',
  pop_dd_email: 'อีเมล — ตรวจสอบและแก้ไขได้ก่อนส่ง',
  pop_dd_link_hint: 'เมื่อกดส่ง {{ph}} จะถูกแทนที่ด้วยลิงก์ลูกค้าใหม่ และลิงก์ลูกค้าเดิมจะใช้ไม่ได้อีก',
  pop_dd_edited: 'คุณแก้ไขอีเมลแล้ว การเปลี่ยนแปลงในช่องด้านบนจะไม่อัปเดตอีเมลอีก',
  pop_dd_rebuild: 'สร้างอีเมลใหม่จากช่องด้านบน',
  pop_need_body: 'เนื้อหาอีเมลว่างเปล่า',
  pop_too_large: 'อีเมลนี้เกินขีดจำกัด 50 MB ต่อการส่งหนึ่งครั้ง (รวมรูปภาพที่วางไว้ด้วย) ยังไม่ได้ส่ง — กรุณาลดขนาด เช่น ลบรูปภาพขนาดใหญ่ที่วางไว้ แล้วส่งอีกครั้ง',
  pop_jc_changed: 'งานมีการเปลี่ยนแปลง — กรุณาโหลดอีเมลใหม่',
  pop_jc_changed_hint: 'สถานะ วันที่เสร็จ หรือผู้รับของงานนี้เปลี่ยนไปหลังจากเตรียมอีเมลฉบับนี้ จึงส่งตามที่แสดงอยู่ไม่ได้ โหลดอีเมลใหม่เพื่อดูอีเมลตามข้อมูลงานปัจจุบัน — สิ่งที่คุณแก้ไขไว้ที่นี่จะถูกแทนที่',
  pop_jc_reload: 'โหลดอีเมลใหม่',
  pop_jc_reloaded: 'งานมีการเปลี่ยนแปลง อีเมลด้านล่างจึงถูกโหลดใหม่ตามข้อมูลงานปัจจุบัน กรุณาตรวจสอบก่อนส่ง',
  pop_jc_no_draft: 'ยังไม่ได้เตรียมอีเมล',
  pop_jc_wait_draft: 'ปุ่ม "ยืนยันและส่ง" จะใช้ไม่ได้จนกว่าอีเมลจะโหลดเสร็จ — ปุ่ม "ตรวจสอบ / แก้ไข" และ "ย้อนกลับ" ยังใช้ได้ตามปกติ',
  pop_jc_retry: 'ลองอีกครั้ง',
};
